import { makeStyles, tokens } from "@fluentui/react-components";
import { flexChildSizeFixed, flexChildSizeFlexible, flexParent, textClip } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * PlanContextDropdown style constants
 */ const contentLinkIconSize = "28px";
const splitButtonHeight = "56px";
const menuItemHeight = "70px";
export const usePlanContextDropdownStyles = makeStyles({
    root: {
        display: "flex",
        alignItems: "center"
    },
    // Menu list styles
    menuRoot: {
        maxWidth: "300px",
        minWidth: "240px",
        maxHeight: "600px",
        overflowY: "auto",
        borderRadius: tokens.borderRadiusXLarge
    },
    // Menu button styles
    customMenuButton: {
        ...flexChildSizeFixed(),
        fontSize: tokens.fontSizeBase200,
        fontWeight: tokens.fontWeightRegular
    },
    linkedBadgeItem: {
        ...flexChildSizeFixed,
        ...flexParent()
    },
    // Menu item styles
    headerItem: {
        ...flexChildSizeFlexible(),
        alignItems: "center",
        lineHeight: tokens.lineHeightBase300,
        minHeight: menuItemHeight
    },
    headerText: {
        ...flexChildSizeFlexible(),
        margin: `${tokens.spacingVerticalXL} ${tokens.spacingHorizontalS} 15px ${tokens.spacingHorizontalS}`,
        display: "inline-block",
        textOverflow: "ellipsis",
        overflow: "hidden",
        fontWeight: tokens.fontWeightSemibold
    },
    headerLink: {
        color: tokens.colorBrandForegroundLink,
        textDecorationLine: "none",
        fontWeight: tokens.fontWeightSemibold,
        ":hover": {
            textDecorationLine: "underline"
        }
    },
    staticItemContent: {
        ...textClip("ellipsis")
    },
    staticText: {
        ...textClip("ellipsis")
    },
    contextItem: {
        alignItems: "center",
        whiteSpace: "nowrap",
        maxWidth: "100%",
        height: splitButtonHeight
    },
    contextItemContent: {
        ...textClip("ellipsis")
    },
    contextItemIcon: {
        ...flexChildSizeFixed(),
        flexShrink: 0,
        height: contentLinkIconSize,
        width: contentLinkIconSize,
        marginLeft: tokens.spacingHorizontalXS,
        marginRight: tokens.spacingHorizontalS
    },
    contextDetailsText: {
        ...textClip("ellipsis"),
        lineHeight: tokens.lineHeightBase200,
        height: "19px"
    },
    contextDetailsSecondaryText: {
        ...flexParent(),
        ...textClip("ellipsis"),
        alignItems: "center",
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase100,
        height: "16px"
    },
    linkDismiss: {
        margin: "0px 5px 0px 0px"
    },
    menuBorder: {
        margin: "3px -4px"
    }
});
